export default "__VITE_ASSET__da5ac17c__"